/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-cycle */
import _ from 'lodash';
import {
  clear,

  collapseAllRows,
  expandRow,
  collapseRow,
  toggleRow,

  clearSelectedSurveys,
  selectSurvey,
  unselectSurvey,
  toggleSelectedSurvey,
  expandAllRows,

  setIsLinking,
  setLinkErrorMessage,
  clearLinkErrorMessage,
} from './actions';
import { ROOT_SLICE } from './constants';
import { initialState } from './initialState';
import {
  selectThisSlice,
  selectExpandedRowMapById,
  selectSelectedSurveysArrMapById
} from './selectors';
import { selectFilteredLinesAggs } from "../LinkSurveysFiltersUI/selectors";
import UTIL from './actions/util';

// const isDefined = v => v !== undefined && v !== null;

const EMPTY_OBJECT = {};

// ************
// PARTS
// ************
const reducerParts = {
	[clear]: state => {
		return {
			...state,
			[ROOT_SLICE]: _.cloneDeep(initialState)
		};
  },

  //
  // EXPANDED ROWS
  //

  [collapseAllRows]: (state) => { 
    const rootSlice = selectThisSlice(state);
		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
        expandedRowMapById: EMPTY_OBJECT
			}
		};
  },

  [expandAllRows]: (state) => { 
    const rootSlice = selectThisSlice(state);
    const items = selectFilteredLinesAggs(state);
		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
        expandedRowMapById: UTIL.expandAllRows(items)
			}
		};
  },

	[expandRow]: (state, { payload: { item } }) => {
    const rootSlice = selectThisSlice(state);
    const items = selectFilteredLinesAggs(state);
    const expandedRowMapById = selectExpandedRowMapById(state);
		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
        expandedRowMapById: UTIL.expandRow(items, expandedRowMapById, item)
			}
		};
  },

	[collapseRow]: (state, { payload: { item } }) => {
    const rootSlice = selectThisSlice(state);
    const expandedRowMapById = selectExpandedRowMapById(state);
		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
        expandedRowMapById: UTIL.collapseRow(expandedRowMapById, item)
			}
		};
  },

	[toggleRow]: (state, { payload: { item } }) => {
    const rootSlice = selectThisSlice(state);
    const items = selectFilteredLinesAggs(state);
    const expandedRowMapById = selectExpandedRowMapById(state);
		const newState = {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
        expandedRowMapById: UTIL.toggleRow(items, expandedRowMapById, item)
			}
    };
    return newState;
  },

  //
  // EXPANDED ROWS
  //

  [clearSelectedSurveys]: (state) => { 
    const rootSlice = selectThisSlice(state);
		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
        selectedSurveysArrMapById: EMPTY_OBJECT
			}
		};
  },

  [selectSurvey]: (state, { payload: { lineAgg, survey } }) => {
    const rootSlice = selectThisSlice(state);
    const selectedSurveysArrMapById = selectSelectedSurveysArrMapById(state);
		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
        selectedSurveysArrMapById: UTIL.selectSurvey(selectedSurveysArrMapById, lineAgg, survey)
			}
		};
  },  

  [unselectSurvey]: (state, { payload: { lineAgg, survey } }) => {
    const rootSlice = selectThisSlice(state);
    const selectedSurveysArrMapById = selectSelectedSurveysArrMapById(state);
		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
        selectedSurveysArrMapById: UTIL.unselectSurvey(selectedSurveysArrMapById, lineAgg, survey)
			}
		};
  },  

  [toggleSelectedSurvey]: (state, { payload: { lineAgg, survey } }) => {
    const rootSlice = selectThisSlice(state);
    const selectedSurveysArrMapById = selectSelectedSurveysArrMapById(state);
		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
        selectedSurveysArrMapById: UTIL.toggleSelectedSurvey(selectedSurveysArrMapById, lineAgg, survey)
			}
    };
  },  

  [setIsLinking]: (state, { payload: { isLinking } }) => {
    const rootSlice = selectThisSlice(state);
		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
        isLinking
			}
    };
  },  

  [setLinkErrorMessage]: (state, { payload: { linkErrorMessage } }) => {
    const rootSlice = selectThisSlice(state);
		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
        linkErrorMessage
			}
    };
  },  

  [clearLinkErrorMessage]: (state) => {
    const rootSlice = selectThisSlice(state);
		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
        linkErrorMessage: undefined
			}
    };
  },  
};

export default reducerParts;
